import FetchCatalog from './Catalog';
import * as Extract from './Extract';
import { FetchBalance } from './Balance';
import FetchCardBrands from './CardBrands';
import FetchCmsStatic from './CmsStatic';
import {
  FetchRegulationCampaign,
  FetchRegulationsVendor,
  FetchRegulationsVendorAndRegulationType,
} from './Regulation';
import FetchShipping, {
  FetchCartAddressShipping,
  FetchCartShipping,
  PutCartShipping,
} from './Shipping';
import { FetchParticipant, PutParticipant } from './Participants';
import FetchShowcase from './Showcase';
import { FetchAvailability } from './Availability';
import {
  AddWishlist,
  FetchSimpleWishlist,
  FetchWishlist,
  RemoveWishlist,
} from './SimpleWishlist';
import { DummyJson } from './DummyJson';
import FetchLoadStores from './Stores';
import { AppendStoreAverage } from './Average';
import FetchAutoComplete from './Autocomplete';
import FetchCart, {
  AddToCart,
  UpdateToCart,
  DeleteToCart,
  AddCouponToCart,
  RemoveCouponCart,
} from './Cart';
import FetchBanners from './Banner';
import FetchTag from './Tag';
import FetchPaymentConfig, {
  CalculateInstallments,
  CreatePurchase,
  getBraspagAuthorizationToken,
} from './Checkout';
import FetchSearch from './Search';
import FetchRedemption from './ViewRedemption';
import { FetchOrdersList } from './Orders/OrdersList';
import { FetchProducts, FetchProductsGeneric, FetchProductsRelated } from './Products';
import FetchPointsPlusCash from './PointsPlusCash';
import { FetchOrderDetais } from './Orders/OrderDetails';
import { FetchTracking } from './Tracking/Tracking';
import { FetchTrackingPGS } from './Tracking/TrackingPGS';
import FetchRatingStore from './RatingStore';
import FetchRatingProduct from './RatingProduct';
import {
  FetchAreaCode,
  FetchMobileOperator,
  FetchRechargeValue,
  SaveMobileRecharge,
} from './MobileOperators';
import { AddInCampaign } from "./AddInCampaign";
import { AddQuotation } from './Quotation';
import { FetchPackagesBySupplierId, redemptionFuelCredit } from './Mileage';
import FetchBillPaymentServices from './BillPaymentServices';
import { FetchAvailabilityGeneric } from './AvailabilityGeneric';
import FetchTemplate from './Template/Template';
import { FetchVendors } from './Vendors/Vendors';

const Apis = {
  FETCH_CATALOG: FetchCatalog,
  FETCH_CART: FetchCart,
  ADD_ITEM_TO_CART: AddToCart,
  UPDATE_ITEM_CART: UpdateToCart,
  DELETE_ITEM_CART: DeleteToCart,
  ADD_COUPON_TO_CART: AddCouponToCart,
  REMOVE_COUPON_TO_CART: RemoveCouponCart,
  FETCH_EXTRACT: Extract.FetchExtract,
  FETCH_EXTRACT_WITH_FILTER: Extract.FetchExtractWithFilter,
  FETCH_EXTRACT_TOTALIZERS: Extract.FetchExtractTotalizer,
  FETCH_CREDIT_TO_EXPIRE: Extract.FetchCreditToExpire,
  FETCH_CAMPAIGN_NAME: Extract.FetchCampaignName,
  FETCH_POINTS_EXPIRE: Extract.FetchPointsToExpire,
  LOAD_BALANCE: FetchBalance,
  FETCH_CARD_BRANDS: FetchCardBrands,
  FETCH_CMS_STATIC: FetchCmsStatic,
  FETCH_BANNERS: FetchBanners,
  FETCH_AUTOCOMPLETE: FetchAutoComplete,
  LIST_REGULATION_CAMPAIGN: FetchRegulationCampaign,
  LIST_REGULATION_VENDOR: FetchRegulationsVendor,
  LIST_REGULATION_VENDOR_AND_REGULATION_TYPE:
    FetchRegulationsVendorAndRegulationType,
  FETCH_SHIPPING: FetchShipping,
  FETCH_CART_SHIPPING: FetchCartShipping,
  FETCH_ADDRESS_SHIPPING: FetchCartAddressShipping,
  UPDATE_CART_SHIPPING: PutCartShipping,
  FETCH_PARTICIPANT: FetchParticipant,
  UPDATE_PARTICIPANT: PutParticipant,
  FETCH_SHOWCASE: FetchShowcase,
  FETCH_AVAILABILITY: FetchAvailability,
  FETCH_AVAILABILITY_GENERIC: FetchAvailabilityGeneric,
  FETCH_STORES: FetchLoadStores,
  FETCH_TAGS: FetchTag,
  FETCH_REDEMPTION: FetchRedemption,
  FETCH_WISHLIST: FetchWishlist,
  FETCH_SIMPLE_WISHLIST: FetchSimpleWishlist,
  ADD_WISHLIST: AddWishlist,
  REMOVE_WISHLIST: RemoveWishlist,
  DUMMY_JSON: DummyJson,
  FETCH_POINTS_CASH_CONFIG: FetchPaymentConfig,
  FETCH_POINTS_CASH_INSTALLMENTS: CalculateInstallments,
  FETCH_CREATE_PURCHASE: CreatePurchase,
  FETCH_BRASPAG_AUTHORIZATION: getBraspagAuthorizationToken,
  APPEND_STORE_RATING: AppendStoreAverage,
  FETCH_SEARCH: FetchSearch,
  FETCH_ORDERS_LIST: FetchOrdersList,
  FETCH_PRODUCTS: FetchProducts,
  FETCH_PRODUCTS_GENERIC: FetchProductsGeneric,
  FETCH_PRODUCTS_RELATED: FetchProductsRelated,
  FETCH_ORDER_DETAILS: FetchOrderDetais,
  FETCH_TRACKING: FetchTracking,
  FETCH_TRACKING_PGS: FetchTrackingPGS,
  FETCH_POINTS_PLUS_CASH: FetchPointsPlusCash,
  FETCH_RATING_STORE: FetchRatingStore,
  FETCH_RATING_PRODUCT: FetchRatingProduct,
  FETCH_MOBILE_OPERATOR: FetchMobileOperator,
  FETCH_AREA_CODE: FetchAreaCode,
  FETCH_RECHARGE_VALUE: FetchRechargeValue,
  SAVE_MOBILE_RECHARGE: SaveMobileRecharge,
  ADD_IN_CAMPAIGN: AddInCampaign,
  ADD_QUOTATION: AddQuotation,
  FETCH_PACKAGES_BY_SUPPLIERID: FetchPackagesBySupplierId,
  REDEMPTION_FUEL_CREDIT: redemptionFuelCredit,
  FETCH_BILL_PAYMENT_SERVICES: FetchBillPaymentServices,
  FETCH_TEMPLATE: FetchTemplate,
  FETCH_VENDORS: FetchVendors,
};

export default Apis;
